import update from 'immutability-helper';
import * as types from './types';

export const initialState = {
  afterInitialization: false,
  keys: new Set(),
  savedRecentlyKeys: new Set(),
  currentActiveDashboard: {},
};

const switchMap = {};

switchMap[types.INIT] = (state) =>
  update(state, {
    $set: initialState,
  });

switchMap[types.SET_AFTER_INITIALIZATION] = (state, action) =>
  update(state, {
    afterInitialization: {
      $set: action.afterInitialization,
    },
  });

switchMap[types.SET_KEYS] = (state, action) =>
  update(state, {
    keys: {
      $set: new Set(action.keys),
    },
  });

switchMap[types.SET_KEY] = (state, action) =>
  update(state, {
    keys: {
      $set: new Set([...Array.from(state.keys), action.key]),
    },
  });

switchMap[types.REMOVE_KEY] = (state, action) =>
  update(state, {
    keys: {
      $set: new Set(
        Array.from(state.keys).filter((key) => parseFloat(key) !== parseFloat(action.key)),
      ),
    },
  });

switchMap[types.REMOVE_ALL_KEYS] = (state) =>
  update(state, {
    keys: {
      $set: new Set(),
    },
    savedRecentlyKeys: {
      $set: new Set(),
    },
  });

switchMap[types.SET_SAVED_RECENTLY_KEYS] = (state, action) =>
  update(state, {
    savedRecentlyKeys: {
      $set: new Set(action.keys),
    },
  });

switchMap[types.SET_SAVED_RECENTLY_KEY] = (state, action) =>
  update(state, {
    savedRecentlyKeys: {
      $set: new Set([...Array.from(state.savedRecentlyKeys), action.key]),
    },
  });

switchMap[types.REMOVE_SAVED_RECENTLY_KEY] = (state, action) =>
  update(state, {
    savedRecentlyKeys: {
      $set: new Set(
        Array.from(state.savedRecentlyKeys).filter(
          (key) => parseFloat(key) !== parseFloat(action.key),
        ),
      ),
    },
  });

switchMap[types.REFRESH_TABS] = (state) =>
  update(state, {
    $merge: {
      keys: new Set(Array.from(state.keys)),
      savedRecentlyKeys: new Set(Array.from(state.savedRecentlyKeys)),
    },
  });

switchMap[types.UPDATE_ACTIVE_DASHBOARD] = (state, action) => {
  const dashboardConfig = action.dashboardConfig || {};

  return update(state, {
    currentActiveDashboard: {
      $set: dashboardConfig,
    },
  });
};

export default (state = initialState, action) =>
  switchMap[action.type] ? switchMap[action.type](state, action) : state;
